




















































































































import Vue from "vue";
import BhSection from "@/components/BhSection.vue";
import { mapMutations } from "vuex";
import { Mutations } from "@/store";
import { JobCodes } from "@/store/jobCodes";

export default Vue.extend({
  name: "Contributors",
  metaInfo: {
    title: "Contributors",
  },
  components: { BhSection },
  methods: {
    ...mapMutations({ setJobCode: Mutations.SET_JOB_CODE }),
  },
  created() {
    this.setJobCode(JobCodes.CONTRIBUTORS);
  },
});
